<template>
  <div class="w-full mx-auto">
    <ViewsGigIndex v-if="runtimeConfig.public.source == 'user'" />
    <ViewsIndex v-else />
  </div>
</template>

<script lang="ts" setup>
import ViewsGigIndex from "@/views/gig/index/index.vue"
import ViewsIndex from "@/views/index/index.vue"

const { t } = useI18n()
const siteName = useSiteName()

const runtimeConfig = useRuntimeConfig()

definePageMeta({
  title: "s360",
  layout: "landing",
  requireLogin: false,
})
useHead({
  title: `seo.index.title${runtimeConfig.public.source == "user" ? "Gig" : ""}`,
  meta: [
    {
      name: "description",
      content: t(
        `seo.index.description${
          runtimeConfig.public.source == "user" ? "Gig" : ""
        }`,
        [siteName],
      ),
    },
    {
      name: "keywords",
      content: t("seo.index.keywords", [siteName]),
    },
  ],
})
</script>
